import { Segmented } from 'antd';
import { useState } from 'react';
import { getFromStorage, storeInLocal } from '../../../../../lib/storage';
import InviteOPPractitioner from './InvitePractitioner/InvitePractitioner.page';

const OfficePracticum = ({ isMinimized }) => {
  const [activeButton, setActiveButton] = useState(() => {
    return getFromStorage('officePracticumSegment') || 'Invite Practitioner';
  });

  const superAdminButton = [
    {
      label: 'Invite Practitioner',
      isActive: activeButton === 'Invite Practitioner',
      onClick: () => setActiveButton('Invite Practitioner'),
    },
  ];

  const handleSegmentedTabChange = (value) => {
    setActiveButton(value);
    storeInLocal('officePracticumSegment', value);
  };

  return (
    <div className={`page-wrapper`}>
      <div className="lg:flex gap-3 justify-between py-3 px-1 items-center ">
        <div className="lg:flex segmented_schedule  rounded-lg w-fit">
          <Segmented
            options={superAdminButton.map((button) => ({
              label: button.label,
              value: button.label,
            }))}
            value={activeButton}
            onChange={(value) => {
              handleSegmentedTabChange(value);
            }}
          />
        </div>
      </div>
      <div>
        {activeButton === 'Invite Practitioner' && (
          <>
            <InviteOPPractitioner />
          </>
        )}
      </div>
    </div>
  );
};

export default OfficePracticum;
